import React from "react";

const Input = ({
    type = "text",
    placeholder,
    value,
    onChange,
    name,
    error,
    onKeyDown,
    className = ""
}) => {
    return (
        <div className="w-full">
            <input
                type={type}
                name={name}
                value={value}
                onChange={onChange}
                onKeyDown={onKeyDown}
                placeholder={placeholder}
                className={`w-full px-4 py-3 rounded-xl border focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white text-gray-800 placeholder-gray-400 transition-all ${error ? 'border-red-500 focus:ring-red-200' : 'border-gray-200'} ${className}`}
            />
            {error && <p className="text-red-500 text-xs mt-1 ml-1">{error}</p>}
        </div>
    );
};

export default Input;
